module.exports = __webpack_public_path__ + "img/v.27ede6bc.jpg";